import { useCallback, useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import styled from "styled-components";
import variables from "../../../assets/js/variables";
import whatsappSvg from "../../../assets/media/icons/whatsapp.svg";
import { getSocialLinkDetail } from "../../../services/miscRequestServices";

const { colors } = variables;

const WhatsAppButton = ({ tooltip = true, size = 48 }) => {
  const [whatsAppUrl, changeWhatsAppUrl] = useState(null);

  const getWhatsAppUrl = useCallback(() => {
    return getSocialLinkDetail("whatsapp").then((res) =>
      changeWhatsAppUrl(res?.url)
    );
  }, []);

  useEffect(getWhatsAppUrl, [getWhatsAppUrl]);

  return (
    <StyledWhatsAppButton
      style={{ width: size, height: size }}
      onClick={() => window.open(whatsAppUrl, "_blank")}
    >
      <ReactSVG src={whatsappSvg || null} />
      {tooltip && (
        <div
          className="Button_tooltip border border-blue rounded text-nowrap text-10 text-md-12 bg-background"
          onClick={(e) => e.stopPropagation()}
        >
          کارشناسان ما آماده پاسخگویی به سوالات شما هستند
        </div>
      )}
    </StyledWhatsAppButton>
  );
};

export default WhatsAppButton;

const StyledWhatsAppButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00eeb8;
  border: unset;
  outline: unset;
  border-radius: 50%;
  cursor: pointer;

  svg {
    width: 36px;
    height: 36px;

    .background {
      fill: ${colors.green};
    }
  }

  .Button_tooltip {
    position: absolute;
    left: 58px;
    top: 50%;
    transform: translateY(-50%);
    color: white;
    padding: 10px 12px;
    line-height: 14px;
    cursor: initial;
    visibility: hidden;
    transition: 300ms;
    opacity: 0;
  }

  &:hover .Button_tooltip {
    visibility: visible;
    opacity: 1;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    left: 15px;
    bottom: 15px;
    .Button_tooltip {
      visibility: visible;
      opacity: 1;
      left: 50px;
      padding: 8px 12px;
      line-height: 12px;
    }
  }
`;
